exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3XEE4Rit1S7G0CuMrFPO6s{width:320px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}@media only screen and (max-width:1400px){._2zEFIJ-JjYEByJZ4t5P6Yq._3XEE4Rit1S7G0CuMrFPO6s{width:calc(100vw - 1080px);min-width:0}}", ""]);
// Exports
exports.locals = {
	"underlay": "_3XEE4Rit1S7G0CuMrFPO6s",
	"shrinkable": "_2zEFIJ-JjYEByJZ4t5P6Yq"
};